import {Component, EventEmitter, inject, Input, Output} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {take} from "rxjs";

@Component({
  selector: 'app-idp-provider-error',
  styleUrls: ['./idp-provider-error.component.scss'],
  templateUrl: './idp-provider-error.component.html',
})
export class IdpProviderErrorComponent {

  path: string;
  error = 'No IDP providers found ';
  errorDescription = '';
  private route: ActivatedRoute = inject(ActivatedRoute);

  ngOnInit() {
    this.path = window.location.origin + window.location.pathname;
    // get error from route fragment
    this.route.fragment.pipe(take(1)).subscribe(fragment => {
      if (fragment) {
        decodeURIComponent(fragment).split('&').forEach((param) => {
          const [key, value] = param.split('=');

          if (key === 'error') {
            this.error = value.replace(/\+/g, ' ');
          }
          if (key === 'error_description') {
            this.errorDescription = value.replace(/\+/g, ' ');
          }
        });
      }
    });
  }
}
